import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgClockIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="clock_svg__nc-icon-wrapper">
      <path d="M32 1C14.907 1 1 14.907 1 32s13.907 31 31 31 31-13.907 31-31S49.093 1 32 1zm0 60C16.01 61 3 47.99 3 32S16.01 3 32 3s29 13.01 29 29-13.01 29-29 29z" />
      <circle data-color="color-2" cx={32} cy={10} r={2} />
      <circle data-color="color-2" cx={54} cy={32} r={2} />
      <circle data-color="color-2" cx={32} cy={54} r={2} />
      <circle data-color="color-2" cx={10} cy={32} r={2} />
      <path
        data-color="color-2"
        d="M36.885 35.471a6.045 6.045 0 0 1-1.414 1.414l9.822 9.822 1.414-1.414-9.822-9.822zM35.851 30.977l8.563-8.563a2 2 0 1 0-2.828-2.828l-8.563 8.563c-.746-.199-1.299-.199-2.046 0L20.414 17.586a2 2 0 1 0-2.828 2.828l10.563 10.563A3.975 3.975 0 0 0 28 32c0 2.206 1.794 4 4 4s4-1.794 4-4c0-.356-.062-.694-.149-1.023z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgClockStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgClockIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ClockIcon: any = SvgClockStyle;
export default ClockIcon;
